module.exports = {"text":"מקור הערביקה: הסיפור האמיתי<br/><div>(או לפחות הסיפור שהכי אהבנו)</div>","srcM3U8":"https://ynethd-i.akamaihd.net/i/0118/300118_NESPRESSoX.mp4/master.m3u8","src":"https://mediadownload.ynet.co.il/0118/300118_NESPRESSoX.mp4","downloadText":"להורדת הסיפור המלא של הקפה","downloadLink":"https://z.ynet.co.il/short/commerce/2018/nespressoFile/nespresso3.pdf"}


//////////////////
// WEBPACK FOOTER
// ./src/api/Video.json
// module id = 51
// module chunks = 0